import ReactGA from "react-ga";

/**
 * Servicio para eventos de Google Analytics
 */
class AnalyticsService {
  /**
   * Registra una vista de página
   * @param {string} path - Ruta de la página
   */
  pageView(path) {
    ReactGA.pageview(path);
  }

  /**
   * Registra un evento de solicitud de oferta
   * @param {Object} data - Datos del evento
   * @param {string} data.userName - Nombre del usuario
   * @param {string} data.offerTitle - Título de la oferta
   */
  trackBidRequest(data) {
    const { userName, offerTitle } = data;

    ReactGA.event({
      category: "Pagina de oferta",
      action: "Solicitud de disponibilidad",
      label: "Solicitud de oferta enviada",
      value: `${userName} solicitó disponibilidad para ${offerTitle}`,
    });
  }

  /**
   * Registra un evento de redención exitosa
   * @param {Object} data - Datos del evento
   * @param {string} data.userName - Nombre del usuario
   * @param {string} data.offerTitle - Título de la oferta
   */
  trackRedemptionSuccess(data) {
    const { userName, offerTitle } = data;

    ReactGA.event({
      category: "Pagina de oferta",
      action: "Redención exitosa",
      label: "Redención completada",
      value: `${userName} redimió el cupón ${offerTitle}`,
    });
  }

  /**
   * Registra un evento de error
   * @param {Object} data - Datos del evento
   * @param {string} data.errorMessage - Mensaje de error
   * @param {string} data.context - Contexto donde ocurrió el error
   */
  trackError(data) {
    const { errorMessage, context } = data;

    ReactGA.event({
      category: "Error",
      action: context || "Error general",
      label: errorMessage,
    });
  }

  /**
   * Registra un evento de apertura de reserva
   * @param {Object} data - Datos del evento
   * @param {string} data.hotelName - Nombre del hotel
   */
  trackReservationClick(data) {
    const { hotelName } = data;

    ReactGA.event({
      category: "Reserva",
      action: "Click en botón reservar",
      label: `Reserva iniciada para ${hotelName}`,
    });
  }
}

const analyticsService = new AnalyticsService();

export default analyticsService;
